import { createSlice } from "@reduxjs/toolkit";
import {
  deleteFailed,
  onErrorCreate,
  onErrorDelete,
  onErrorUpdate,
  onSetError,
  onSetLoaded,
  onSetLoadedCreate,
  onSetLoadedDelete,
  onSetLoadedUpdate,
  updateFailed,
} from "./../utils/loadedError";

export const formDataStorage = new Map();
export const saveFormData = (tempId, { file, metadata }) => {
  formDataStorage.set(tempId, { file, metadata });
};
export const getFormData = (tempId) => {
  return formDataStorage.get(tempId);
};
export const deleteFormData = (tempId) => {
  formDataStorage.delete(tempId);
};
export const clearAllFormData = () => {
  formDataStorage.clear();
};

const initialDocumentsState = {
  filter: {
    search: "",
    selectedTypeIds: [],
    selectedHashtagIds: [],
    dateCreate: null,
  },
  data: [],
  error: null,
  isLoaded: false,
  isLoadedCreate: true,
  isLoadedUpdate: true,
  isLoadedDelete: true,
  errorCreate: null,
  errorUpdate: null,
  errorDelete: null,
  uploadProgress: 0,
  // downloadProgress: 0,
  isUploadingServer: false,
  isUploading: false,
};

const documentsSlice = createSlice({
  name: "documents",
  initialState: initialDocumentsState,
  reducers: {
    onClearStore(state) {
      state.data = [];
      state.error = null;
      state.isLoaded = false;
      state.isLoadedCreate = true;
      state.isLoadedUpdate = true;
      state.isLoadedDelete = true;
      state.errorCreate = null;
      state.errorUpdate = null;
      state.errorDelete = null;
      state.uploadProgress = 0;
      // state.downloadProgress = 0;
      state.isUploading = false;
      state.isUploadingServer = false;
    },
    onSetData(state, action) {
      state.data = action.payload;
      state.isLoaded = true;
      state.error = null;
    },
    onSetLoaded,
    onSetError,
    onSetLoadedCreate,
    onSetLoadedUpdate,
    onSetLoadedDelete,
    onErrorCreate,
    onErrorUpdate,
    onErrorDelete,
    updateFailed,
    deleteFailed,
    // createFailed(state, action) {
    //   let errorMessage = action.payload.errorMessage;
    //   state.data = state.data.filter((item) => item.isUploading !== true);
    //   state.errorCreate = errorMessage;
    // },
    createFailedDocument(state, action) {
      const { tempId, errorMessage } = action.payload;
      const index = state.data.findIndex((item) => item.id === tempId);
      if (index !== -1) {
        state.data[index].isUploading = false;
        state.data[index].hasError = true;
        state.data[index].errorMessage = errorMessage;
      }
    },
    addDraftDocument(state, action) {
      const { formData, userId } = action.payload;
      const { metadata } = Object.fromEntries(formData);
      const parsedMetadata = JSON.parse(metadata);
      const files = formData.getAll("files");
      files.forEach((file, i) => {
        const meta = parsedMetadata[i] || {};
        state.data.unshift({
          title: meta.title,
          description: meta.description,
          hashtags: meta.hashtags,
          originalFilename: file.name,
          fileExtension: `.${file.name.split(".").pop()}`,
          // fileType: "video/mp4",
          // fileSize: 154922340,

          // filename: "4aa0b26d-0adb-4722-be45-b7078dc9a1ac.mp4",
          // filePath: "uploads/4aa0b26d-0adb-4722-be45-b7078dc9a1ac.mp4",
          uploadedBy: userId,
          // createdAt: file.lastModified,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          id: meta.id,
          isUploading: true,
        });
      });
    },
    addDocument(state, action) {
      const doc = action.payload;
      const index = state.data.findIndex((item) => item.id === doc.tempId);
      if (index !== -1) {
        state.data[index] = doc;
      }
      deleteFormData(doc.tempId);
      state.isLoadedCreate = true;
      state.errorCreate = null;
    },
    updateDocument(state, action) {
      const index = state.data.findIndex((doc) => doc.id === action.payload.id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
      state.isLoadedUpdate = true;
      state.errorUpdate = null;
    },
    removeDocument(state, action) {
      state.data = state.data.filter((doc) => doc.id !== action.payload);
      state.isLoadedDelete = true;
      state.errorDelete = null;
    },
    setUploadProgress(state, action) {
      state.uploadProgress = action.payload;
    },
    // setDownloadProgress(state, action) {
    //   state.downloadProgress = action.payload;
    // },
    setUploadingServer(state, action) {
      state.isUploadingServer = action.payload;
    },
    setUploading(state, action) {
      state.isUploading = action.payload;
    },
    onChangeSearch(state, action) {
      state.filter.search = action.payload.toLowerCase().trim();
    },
    onChangeSelectedTypeIds(state, action) {
      state.filter.selectedTypeIds = action.payload;
    },
    onChangeselectedHashtagIds(state, action) {
      state.filter.selectedHashtagIds = action.payload;
    },
    onChangeDateCreate(state, action) {
      state.filter.dateCreate = action.payload;
    },
    clearAllFilters(state) {
      state.filter.search = "";
      state.filter.selectedTypeIds = [];
      state.filter.selectedHashtagIds = [];
    },
  },
});

export const documentsActions = documentsSlice.actions;
export default documentsSlice.reducer;
